import { render, staticRenderFns } from "./b-admin-approved.vue?vue&type=template&id=63230fa8&"
import script from "./b-admin-approved.vue?vue&type=script&lang=js&"
export * from "./b-admin-approved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports